// extracted by mini-css-extract-plugin
export default {"scroll":"Scroll_scroll__Aofnm","noDisplay":"Scroll_noDisplay__sA-TB"};